import { ALL_BUTTON_POSITION_LIST } from '@/common/manager/position/button-position';
import { calculateTextExprValue } from '@/common/util/util';
export const config = {
    value: 'setTabActiveKey',
    position: ALL_BUTTON_POSITION_LIST,
    action: (arg) => {
        const { buttonConfig, _context } = arg || {};
        const { options } = buttonConfig || {};
        const { activeKey, _bindTab } = options || {};
        const realActiveKey = calculateTextExprValue(activeKey, {
            state: _context?.state,
            recordDataSource: {},
        });
        if (realActiveKey && _bindTab) {
            const dom = _context?.$?.(_bindTab);
            if (typeof dom?.setTabActiveKey === 'function') {
                dom.setTabActiveKey(realActiveKey);
            }
        }
    },
};
